import * as THREE from "three";

export class Lights {
  constructor(scene) {
    this.ambient = new THREE.AmbientLight(0xffffff, 1.5);
    scene.add(this.ambient);
    this.directional = new THREE.DirectionalLight(0xffffff, 3);
    this.directional.position.set(10, 20, 10);
    this.directional.castShadow = true;
    this.directional.shadow.mapSize.width = 1024;
    this.directional.shadow.mapSize.height = 1024;
    this.directional.shadow.camera.near = 0.5;
    this.directional.shadow.camera.far = 100;
    this.directional.shadow.camera.left = -50;
    this.directional.shadow.camera.right = 50;
    this.directional.shadow.camera.top = 50;
    this.directional.shadow.camera.bottom = -50;
    scene.add(this.directional);
  }
}
